import { alpha, css, styled } from '@mui/material';
import { device } from 'src/constants/mediaQueries';

export function SideNavBase({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <MenuContainer data-testid="side-menu">
      <MenuContent>{children}</MenuContent>
    </MenuContainer>
  );
}

const MenuContainer = styled('aside')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 17rem;
  position: absolute;
  margin-top: 1rem;
  top: 0;
  left: 0;
  padding: 2rem;
  padding-right: 0;
  border-bottom-right-radius: 25px;
  border-top-right-radius: 25px;
  box-shadow: 0 0rem 0.6rem grey;
  ${({ theme }) => css`
    background-color: ${theme.palette.background.paper};
    border-top: 1px solid ${alpha(theme.palette.primary.main, 0.3)};
    border-right: 1px solid ${alpha(theme.palette.primary.main, 0.3)};
    border-bottom: 1px solid ${alpha(theme.palette.primary.main, 0.3)};
  `}
  @media only screen and ${device.mobileOrTablet} {
    box-shadow: none;
    position: static;
    min-height: auto;
    width: 100%;
    border: none;
    border-radius: 0;
    padding: 0;
  }
`;

const MenuContent = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: ${({ theme }) => theme.spacing(0.75)};
  @media only screen and ${device.mobileOrTablet} {
    width: 100%;
    align-items: center;
    padding: 0;
  }
`;
